import { PreceptorFeedbackScore } from "./PreceptorFeedbackScore"

export function PreceptorFeedbackScores({ scores, isLoading }) {
    if (!isLoading && (!scores || scores.length === 0)) {
        return <div className="text-gray-600 fs-6 py-6">No feedback data available yet.</div>
    }

    return (
        <div className="mb-0">
            {scores.map((row) => (
                <PreceptorFeedbackScore key={row.question_id} {...row} isLoading={isLoading} />
            ))}
            <div className="separator" />
        </div>
    )
}
